// RecipeResultsTable.jsx
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@mui/material';

const RecipeResultsTable = ({ title, ingredients, color }) => {
  const [strikeoutItems, setStrikeoutItems] = useState(new Set());
  
  const totalWeight = ingredients.reduce((sum, ing) => sum + ing.grams, 0);
  
  const toggleStrikeout = (ingredientId) => {
    setStrikeoutItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(ingredientId)) {
        newSet.delete(ingredientId);
      } else {
        newSet.add(ingredientId);
      }
      return newSet;
    });
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" color={color} gutterBottom sx={{ mb: 2 }}>
        {title} ({totalWeight.toFixed(1)}g)
      </Typography>
      <TableContainer component={Paper} elevation={0} variant="outlined">
        <Table size="small">
          <TableBody>
            {ingredients.map((ingredient) => {
              const isStrikedOut = strikeoutItems.has(ingredient.id);
              return (
                <TableRow 
                  key={ingredient.id}
                  onClick={() => toggleStrikeout(ingredient.id)}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <TableCell 
                    sx={{ 
                      py: 2,
                      textDecoration: isStrikedOut ? 'line-through' : 'none',
                      opacity: isStrikedOut ? 0.6 : 1,
                    }}
                  >
                    {ingredient.name}
                  </TableCell>
                  <TableCell 
                    align="right" 
                    sx={{ 
                      py: 2,
                      textDecoration: isStrikedOut ? 'line-through' : 'none',
                      opacity: isStrikedOut ? 0.6 : 1,
                    }}
                  >
                    {ingredient.percentage}%
                  </TableCell>
                  <TableCell 
                    align="right" 
                    sx={{ 
                      py: 2,
                      textDecoration: isStrikedOut ? 'line-through' : 'none',
                      opacity: isStrikedOut ? 0.6 : 1,
                    }}
                  >
                    <strong>{ingredient.grams}g</strong>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RecipeResultsTable;